"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationResultLogPayloadSchema = exports.aiValidationExecutionPayloadSchema = exports.aiValidationExecutionObservationSchema = exports.aiValidationExecutionStatusSchema = void 0;
const zod_1 = require("zod");
exports.aiValidationExecutionStatusSchema = zod_1.z.enum(['succeeded', 'failed']);
exports.aiValidationExecutionObservationSchema = zod_1.z.object({
    conversationId: zod_1.z.string(),
    sessionId: zod_1.z.string(),
    agentId: zod_1.z.string(),
    triggerId: zod_1.z.string(),
    analysisRunId: zod_1.z.string().optional(),
    subject: zod_1.z
        .object({
        typeName: zod_1.z.string(),
        subjectKey: zod_1.z.string().optional(),
        subjectFingerprint: zod_1.z.string().optional(),
    })
        .optional(),
    startedAt: zod_1.z.string(),
    completedAt: zod_1.z.string(),
    status: exports.aiValidationExecutionStatusSchema,
    error: zod_1.z
        .object({
        name: zod_1.z.string().optional(),
        message: zod_1.z.string(),
    })
        .optional(),
});
exports.aiValidationExecutionPayloadSchema = zod_1.z.object({
    agentExecution: exports.aiValidationExecutionObservationSchema,
});
exports.validationResultLogPayloadSchema = zod_1.z.object({
    generatedAt: zod_1.z.string(),
    configurationSnapshot: zod_1.z.unknown().optional(),
    rawPayloadRef: zod_1.z.string().nullable(),
    agentExecution: exports.aiValidationExecutionObservationSchema.optional(),
});
//# sourceMappingURL=validation-result-log-payload.js.map